import { createSelector } from 'reselect';
import config from '../config.json';
import finalImages from '../../assets/finals';

const finals = config.finals;
const wordState = state => state.game.currentWord;
const keyboardState = state => state.game.keyboard;
const levelState = state => state.game.level;

export const final = createSelector(
    levelState,
    (levelState) => {
        let f = 0;
        if ((levelState > 3) && (levelState <= 6)){
            f = 1;
        }
        if ((levelState >= 7) && (levelState <= 8)){
            f = 2;
        }
        if (levelState > 8){
            f = 3;
        }
        return {
            image: finalImages[f],
            text: finals[f]
        }
    }
)

export const word = createSelector(
    wordState,
    keyboardState,
    (
      wordState,
      keyboardState,
    ) => {
        const wordChars = wordState.map(char => {
  	        if (keyboardState[char] === 1) {
    	        return char;
            } else {
    	        return '_';
            }
        })
        return wordChars;
    }
)
